import React, { useEffect, useRef, useState } from 'react';



import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';

import { ImageButton } from './CustomImageButton';

import CloseIcon from 'assets/images/close.svg';
import ArrowIcon from 'assets/images/tree_arrow_bottom.png';

import './CustomDropGroup.scss';

export function CustomDropGroup({
  type,
  data,
  action,
  defalutShowAll,
  className,
  removedItems,
  disabled,
  getItemLabel = ()=> {},
}) {
  const [show, setShow] = useState({});
  const haveInitData = useRef();
  useEffect(()=> {
    if (defalutShowAll && !haveInitData.current && data?.length>0) {
      const allShowData = data.reduce((res, v)=>{
        res[v?.id] = true
        return res
      }, {})
      haveInitData.current = true
      setShow(allShowData)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defalutShowAll, data?.length])

  return (
    <>
      {data?.map((groupMall) => {
        return (
          <div className="one-group">
            <div className="one-group-header">
              <div
                className="one-group-header-title"
                onClick={() => {
                  setShow({
                    ...show,
                    [groupMall.id]: !show[groupMall.id],
                  });
                }}
              >
                <ImageButton
                  image={ArrowIcon}
                  className={show[groupMall.id] ? 'expand' : 'shrink'}
                  action={() => {}}
                />
                <CustomTitleLabel
                  title={`${groupMall.id ? `[ID: ${groupMall.id}]` : ''} ${groupMall.name}`}
                />
              </div>

              {disabled ? null : (
                <ImageButton
                  image={CloseIcon}
                  className={'close'}
                  action={() => {
                    action({ type, obj: groupMall });
                  }}
                />
              )}
            </div>
            {show[groupMall.id] ? (
              <ul>
                {groupMall.stores.map((s) => {
                  return (
                    <>
                      <li>
                        <div class="dot"/>
                        {
                          (getItemLabel && getItemLabel(s))
                          || `[ID: ${s.id}][${s.isOnlineStore ? 'Online' : 'Offline'}] ${s.name}${s.visibleInFrontEnd ? '' : ' (closed)'}`
                        }
                        {disabled ? null : (
                          <ImageButton
                            image={CloseIcon}
                            className={'close2'}
                            action={() => {
                              action({ type: 'store', obj: s });
                            }}
                          />
                        )}
                      </li>
                    </>
                  );
                })}
              </ul>
            ) : null}
          </div>
        );
      })}
    </>
  );
}